// const prod = "http://35.240.175.255:8080/api/v1/web";
// const dev = "http://35.247.176.96:8080/api/v1/web";
// export const urlAPI = 'http://localhost:8080/api/v1/web';
// export const urlAPI = 'https://kidz.loxleyorbit.com:8080/api/v1/web';

// export const urlAPI = 'http://34.126.116.141:8080/api/v1/web';
// export const urlComAPI = 'http://34.126.116.141:8080/api';

export const urlAPI = 'https://loxtrade.orb-sams.mobi:8080/api/v1/web';
export const urlComAPI = 'https://loxtrade.orb-sams.mobi:8080/api';

// export const urlComAPI = 'https://demo.orb-sams.mobi:8080/api';  //UAT
// export const urlAPI = 'https://demo.orb-sams.mobi:8080/api/v1/web';  //UAT

export const GoogleMapsAPI = 'AIzaSyCr8dYXfkQUzH1qYMoBgqjtWTqLgbydr_U';
// export const GoogleMapsAPI = 'AIzaSyAw9YFjx0J8Cy-sT5zeTdZ6oW8drRSliE0';

// {process.env.NODE_ENV === 'development' ?
//                         "http://35.247.176.96:8080/api/v1/web"
//                       : process.env.NODE_ENV === 'production' ?
//                         "http://35.240.175.255:8080/api/v1/web"
//                       };
// export const urlAPI = "https:///api-bac.firebaseapp.com/api";
// export const urlAPI = "https://api-json-bac.firebaseapp.com/api";
// 13: 50 NEUNG superadmin
// 13: 50 NEUNG OrbitOnly1
// p.aaaa@stu.bac.ac.th  14051994 BAC57

export const headerCallAPI = {
  headers: {
    // Authorization: "Bearer " + "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiZWFiZGM4ZTNhYmU0ZmZiYTA2MGVjNjI0OGNmODA5Y2Q0YjQ2MmIzYWEwNjJjYmU3ZWFmYWIyOWQyMzNiYjUxMTU4ZDI5OGY1OGVjZTMwZDAiLCJpYXQiOjE2MTY0MTI0NzYsIm5iZiI6MTYxNjQxMjQ3NiwiZXhwIjoxNjQ3OTQ4NDc2LCJzdWIiOiI1Iiwic2NvcGVzIjpbXX0.pa4cEZY07AzHxNc-6hFfyrVJBpKI4EDAB3cZqzlC93gP-OLkasVZisXOsCnzhnQvJbUN12wPyd0bbFJcB0YVYyO08F5KeQllTMgy1Nl13vREuErGWNjFvThU67gwFc2tn2qkX-fRXrlCxi1mBeL6fPqUBXFmHaO9hRAryGNU-jCRQ9Xd4Kznvx9X8sFOHQJucr97WRC1KIERziZUGRHrV18sEmvqQ6z6xOHUVI0q-g2iY5QAs4_O5L5yFgJ0ETWpc4JMq03Kg28znsxWuWL3tQJfMHqAY-smOOB5oKsE0lEwejdj5X_DAAv3LaSsJYJTKNxWudiKFvRRSWqQ6I7qz8z18p8fTKytB_RZIGSx8pGYT4b5p9YzVgB2oBamyzNpcIzIgM1h2LqryQ0UnZ3eb-icpfhRHwCVvnEeGoWoc2t7WMcBvplxj-v1uCOWkbN_OspjgyjcdizMWItSXf7Cyu9I1z7uQNiOg8J6Jglt9qVhqnnsZU3vN_Vw6-gCgEjlFem_Pa_h3ojNC2wGMy60Op_JugWN1JHEeqBYYDpIwfzt2dutqNEGa7K08bp8Ng-PZBr8v3_l2tgeCasw3usJvk_OW2GRRTUveT0Px9FO9SZs3Yc85UHzGlD9JvRiagonTsIcetV9PZOLdTXYhFzIKofDz3tPSws4XytiEN12nKY",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*"

    // "Content-Type": "multipart/form-data"
  },
  // localStorage.getItem("bac_access_token"),
  
};
// export const headerFileCallAPI = {
//   headers: {
//     Authorization: "Bearer " + localStorage.getItem("bac_access_token"),
//     Accept: "application/json"
//     // "Content-Type": "multipart/form-data"
//   }
// };

export const colorTheme = "#BC4123";
export const colorTheme2 = "#2897E3";


export const options_religion = [
  { key: "b", text: "Buddhism", value: "Buddhism" },
  { key: "c", text: "Christian", value: "Christian" },
  { key: "i", text: "Islam", value: "Islam" },
  { key: "n", text: "None", value: "None" },
];
export const options_degree = [
  { key: "s", text: "Senior High School", value: "Senior High School" },
  { key: "b", text: "Bachelor Degree", value: "Bachelor Degree" },
  { key: "m", text: "Master Degree", value: "Master Degre" },
  { key: "d", text: "Doctor Degree", value: "Doctor Degree" },
];
export const options_regisstatus = [
  { key: "r", text: "Registered", value: "Registered" },
  { key: "u", text: "Unregistered", value: "Unregistered" },
  // ,
  // { key: "g", text: "Graduated", value: "Graduated" }
];

export const options_studentstatus = [
  { key: "a", text: "Active", value: "Active" },
  { key: "i", text: "Inactive", value: "Inactive" },
  { key: "g", text: "Graduated", value: "Graduated" },
  { key: "d", text: "Drop", value: "Drop" },
  { key: "l", text: "Leave", value: "Leave" },
  { key: "t", text: "Terminated", value: "Terminated" },
];



export const options_active = [
  { key: "a", text: "Active", value: "Active" },
  { key: "i", text: "Inactive", value: "Inactive" },
];


export const options_gender = [
  { key: "a", text: "Male", value: "Male" },
  { key: "i", text: "Female", value: "Female" },
];


export const options_title_eng = [
  { key: "1", value: "Mr.", text: "Mr." },
  { key: "2", value: "Mrs.", text: "Mrs." },
  { key: "3", value: "Miss", text: "Miss" }
];
export const options_title_th = [
  { key: "1", value: "นาย", text: "นาย" },
  { key: "2", value: "นาง", text: "นาง" },
  { key: "3", value: "นางสาว", text: "นางสาว" },
  { key: "4", value: "เด็กหญิง", text: "เด็กหญิง" },
  { key: "5", value: "เด็กชาย", text: "เด็กชาย" },
];


export const permission = [
  {
    group: "Personnel",
    permission: [
      {
        label: "Manage Instructor",
        name: "manage-instructor",
      },
      {
        label: "View Instructor",
        name: "view-instructor",
      },
      {
        label: "Manage Student",
        name: "manage-student",
      },
      {
        label: "View Student",
        name: "view-student",
      },
      {
        label: "Manage Staff",
        name: "manage-staff",
      },
      {
        label: "View Staff",
        name: "view-staff",
      },
      {
        label: "View Internal Note",
        name: "view-internalnote",
      },
    ],
  },
  {
    group: "Academic",
    permission: [
      // {
      //   label: "Manage E-Book",
      //   name: "manage-ebook"
      // },
      {
        label: "View E-Book",
        name: "view-ebook",
      },
      // {
      //   label: "Manage Portfolio",
      //   name: "manage-portfolio"
      // },
      {
        label: "View Portfolio",
        name: "view-portfolio",
      },
      {
        label: "Manage Flight Training Record (Student)",
        name: "manage-flighttraining-student",
      },
      {
        label: "Manage Flight Training Record (Instructor)",
        name: "manage-flighttraining-instructor",
      },
      {
        label: "Manage Flight Training Record (Admin)",
        name: "manage-flighttraining-admin",
      },
      {
        label: "Manage Registration",
        name: "manage-registration",
      },
      {
        label: "Manage Ground Attendance (Admin)",
        name: "manage-groundtraining-admin",
      },
      {
        label: "Manage Ground Attendance (Instructor)",
        name: "manage-groundtraining-instructor",
      },

      // {
      //   label: "Manage Discipline Score",
      //   name: "manage-disciplinescore"
      // },
      // {
      //   label: "Manage Score",
      //   name: "manage-score"
      // }
    ],
  },
  {
    group: "Schedule",
    permission: [
      {
        label: "Manage Schedule",
        name: "manage-schedule",
      },
      {
        label: "View Schedule",
        name: "view-schedule",
      },
      {
        label: "View Schedule Tracking",
        name: "view-schedule-tracking",
      },
      {
        label: "Manage Flight Table",
        name: "manage-flighttable",
      },
      {
        label: "View Flight Table",
        name: "view-flighttable",
      },
      {
        label: "Manage Flight Hour Record",
        name: "manage-flighthourrecord",
      },
      {
        label: "Save Flight Hour Record",
        name: "save-flighthourrecord",
      },
    ],
  },
  {
    group: "Resource",
    permission: [
      {
        label: "Manage Academic",
        name: "manage-academic",
      },
      {
        label: "Manage Aircraft & Simulator",
        name: "manage-aircraftsimulator",
      },
      {
        label: "Manage Room",
        name: "manage-room",
      },
    ],
  },
  {
    group: "Report",
    permission: [
      {
        label: "View Report",
        name: "view-report",
      },
    ],
  },
  {
    group: "Management",
    permission: [
      {
        label: "Manage Alert & News",
        name: "manage-alertnews",
      },
      {
        label: "Manage Aircraft & Simulator",
        name: "manage-aircrafts",
      },
      {
        label: "Manage Personnel",
        name: "manage-personnel",
      },
      {
        label: "Manage Room (Room Location)",
        name: "manage-roomlocation",
      },
      {
        label: "Manage Ground Instruction Type",
        name: "manage-groundinstructiontype",
      },
      {
        label: "Manage Role & Permission",
        name: "manage-role",
      },
      {
        label: "Manage E-Book",
        name: "manage-ebook",
      },
      {
        label: "Manage Discipline Score",
        name: "manage-disciplinescore",
      },
      {
        label: "Manage Flight Time Rule",
        name: "manage-flighttimerule",
      },
      {
        label: "Manage User (Student)",
        name: "manage-user-student",
      },
      {
        label: "Manage User (Instructor / Staff)",
        name: "manage-user",
      },
    ],
  },
];

